"use client";

import React from "react";
import Button from "@/components/ui/Button";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselLastProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function CarouselLast({
  variant = "outline",
  size = "icon",
  icon = "chevron-last",
  "aria-label": ariaLabel = "Last slide",
  className,
  ...props
}: CarouselLastProps) {
  const canScrollLast = useCarouselStore(state => state.canScrollLast);
  const scrollLast = useCarouselStore(state => state.scrollLast);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleOnClick = React.useCallback(() => {
    scrollLast();
  }, [scrollLast]);

  return (
    <Button.Icon
      variant={variant}
      size={size}
      icon={icon}
      data-slot="carousel-last"
      disabled={!canScrollLast}
      onClick={handleOnClick}
      className={cn(className, classes)}
      aria-label={ariaLabel}
      {...native}
    />
  );
}

export default CarouselLast;
